import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/App.scss";
import "./styles/media.scss";
import { Provider } from "react-redux";
import store from "./store/store";
import Preload from "./components/Preload/Preload";
import Cookies from "js-cookie";

const root = ReactDOM.createRoot(document.getElementById("root"));
const queryParams = new URLSearchParams(window.location.search);

const urlVisitorId = queryParams.get("visitor_id");
const cookieVisitorId = Cookies.get("visitor_id");

let visitorId = urlVisitorId || cookieVisitorId;
let sourceVisitorId = null;

if (urlVisitorId && cookieVisitorId && urlVisitorId !== cookieVisitorId) {
  sourceVisitorId = cookieVisitorId;
  Cookies.set("source_visitor_id", sourceVisitorId, { expires: 30 });
}

if (!visitorId) {
  visitorId = crypto.randomUUID();
}

Cookies.set("visitor_id", visitorId, { expires: 365 });

window.__VISITOR_ID__ = visitorId;
window.__SOURCE_VISITOR_ID__ = sourceVisitorId;

const Main = () => {
  const [screenLoading, setScreenLoading] = useState(true);
  const images = [
    `${process.env.REACT_APP_BASENAME}/img/landing/h1.webp`,
    `${process.env.REACT_APP_BASENAME}/img/landing/h2.webp`,
    `${process.env.REACT_APP_BASENAME}/img/landing/h3.webp`,
    `${process.env.REACT_APP_BASENAME}/img/landing/h4.webp`,
    `${process.env.REACT_APP_BASENAME}/img/landing/h5.webp`,
    `${process.env.REACT_APP_BASENAME}/img/landing/h6.webp`,
    `${process.env.REACT_APP_BASENAME}/img/landing/h7.webp`,
    `${process.env.REACT_APP_BASENAME}/img/landing/h8.webp`,
    `${process.env.REACT_APP_BASENAME}/img/landing/h9.webp`,
    `${process.env.REACT_APP_BASENAME}/img/landing/h10.webp`,
  ];
  useEffect(() => {
    setScreenLoading(true);

    const loadImages = async () => {
      const promises = images.map(
        (src) =>
          new Promise((resolve) => {
            const img = new Image();
            img.src = src;
            img.onload = img.onerror = resolve;
          })
      );

      await Promise.all(promises);
      setScreenLoading(false);
    };

    loadImages();
  }, []);

  return (
    <div className="container">
      <Provider store={store}>
        {screenLoading && <Preload />}
        <App />
      </Provider>
    </div>
  );
};

root.render(<Main />);
